/**
 * Created by Allan on 2021/04/09.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/dashboard',
        /*alias:'/',*/
        redirect:'/dashboard/data',
        meta:{
            title:'Dashboard',
            icon:'el-icon-s-data',
            menuId:'12'
        },
        component:Frame,
        children:[
            {
                path:'index',
                name:'dataIndex',
                meta:{
                    title:'Dashboard',
                    keepAlive:true,
                    // menuId:'13',
                    menuId:'78',
                },
                component:resolve => require(['@/views/dashboard/dataIndex/index'], resolve)
            },
            /*{
                path:'data',
                name:'dataCount',
                meta:{
                    title:'数据模块1',
                    menuId:'13'
                },
                component:resolve => require(['@/views/dashboard/dataCount/index'], resolve)
            },*/
            {
                path:'module',
                name:'dataModule',
                meta:{
                    title:'数据模块',
                    keepAlive:true,
                    menuId:'13'
                },
                component:resolve => require(['@/views/dashboard/dataModule/index'], resolve)
            },
            {
                path:'model',
                name:'modelMonitor',
                meta:{
                    title:'模型监控',
                    menuId:'84'
                },
                component:resolve => require(['@/views/dashboard/modelMonitor/index'], resolve)
            },
            {
                path:'business',
                name:'formBusiness',
                meta:{
                    title:'业务总览',
                    keepAlive:true,
                    menuId:'24'
                },
                component:resolve => require(['@/views/dashboard/formBusiness/index'], resolve)
            },
            {
                path:'businessExtension',
                name:'formBusinessExtension',
                meta:{
                    title:'业务总览(展期)',
                    keepAlive:true,
                    menuId:'24'
                },
                component:resolve => require(['@/views/dashboard/formBusinessExtension/index'], resolve)
            },
            {
                path:'conversion',
                name:'formConversion',
                meta:{
                    title:'转化明细',
                    keepAlive:true,
                    menuId:'25'
                },
                component:resolve => require(['@/views/dashboard/formConversion/index'], resolve)
            },
            /*{
                path:'loanmarket',
                name:'loanMarket',
                meta:{
                    title:'贷超转化',
                    keepAlive:true,
                    menuId:'80'
                },
                component:resolve => require(['@/views/dashboard/loanMarket/index'], resolve)
            },*/
            {
                path:'advertising',
                name:'advertisingConsume',
                meta:{
                    title:'投放消耗',
                    keepAlive:true,
                    menuId:'80'
                },
                component:resolve => require(['@/views/dashboard/advertisingConsume/index'], resolve)
            },
            {
                path:'postloan',
                name:'formPostloan',
                meta:{
                    title:'贷后表现',
                    keepAlive:true,
                    menuId:'26'
                },
                component:resolve => require(['@/views/dashboard/formPostloan/index'], resolve)
            },
            /*{
                path:'collection',
                name:'formCollection',
                meta:{
                    title:'催收表现',
                    keepAlive:true,
                    menuId:'27'
                },
                component:resolve => require(['@/views/dashboard/formCollection/index'], resolve)
            },*/
            {
                path:'collectionperformance',
                name:'collectionPerformance',
                meta:{
                    title:'催收表现',
                    keepAlive:true,
                    menuId:'27'
                },
                component:resolve => require(['@/views/dashboard/collectionPerformance/index'], resolve)
            },
            {
                path:'riskcontrol',
                name:'formRiskcontrol',
                meta:{
                    title:'风控报表',
                    keepAlive:true,
                    menuId:'83'
                },
                component:resolve => require(['@/views/dashboard/formRiskcontrol/index'], resolve)
            },
            {
                path:'reloan',
                name:'riskReloan',
                meta:{
                    title:'复借率监控',
                    menuId:'57'
                },
                component:resolve => require(['@/views/dashboard/reloan/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/dashboard.js